export default "__VITE_ASSET__Dt1YJFXA__"